<div class="input-container">
    <div *ngIf="multiSelect" class="label-normal">
        {{ controlName }}
    </div>
    <div [ngClass]="multiSelect ? 'contact-container' : ''">
        <div *ngIf="multiSelect" [ngClass]="editing ? 'selected-values' : ''">
            <div class="contact-edit" *ngIf="selected && selected.length > 0">
                <div *ngFor="let contact of selected" class="contact-row">
                    <b class="purple font-13 pointer contact-name" (click)="openAddContactModal(contact)">
                        {{ contact.first_name }} {{ contact.last_name }}
                    </b>
                    <span class="pointer contact-destroy" *ngIf="editing" (click)="unselect(contact)">
                        <i class="fas fa-times"></i>
                    </span>
                </div>
            </div>
        </div>
        <div *ngIf="!multiSelect">
            <div>
                <div *ngIf="!selected && !editing">
                    <div *ngIf="!editing" class="purple font-12">
                        <b>{{controlName}} is not added</b>
                    </div>
                </div>
                <div *ngIf="selected">
                    <div class="single-contact-container pointer" (click)="openAddContactModal(selected)">
                        <p><b>{{controlName}}</b></p>
                        <p class="fullname">{{ selected.first_name }} {{ selected.last_name }}</p>
                        <div class="delete-button pointer" (click)="unselect(selected); $event.stopPropagation()">
                            <i class="fas fa-times"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="editing && (multiSelect || !selected)">
            <div class="input-container" id="contact-input-container" *ngIf="(!editing) || optionContacts.length > 0"
                [ngClass]="{'inputted': selected && ((!multiSelect && selected.id) || (multiSelect && selected.length > 0)), 'edit-disable':  (!this.editing)}">
                <ng-select
                    (change)="onSelectionChanged($event)"
                    (keydown)="checkAndSetClass($event)"
                    (focus)="checkAndSetClass($event)"
                    (input)="checkAndSetClass($event)"
                    (blur)="checkAndSetClass($event)"
                    (remove)="unselect($event?.value)"
                    (add)="select($event)"
                    [(ngModel)]="selected"
                    [ngClass]="{ 'invalid-input-validation': touched && invalid }"
                    [items]="optionContacts"
                    [clearable]="clearable"
                    [disabled]="(!editing)"
                    [multiple]="multiSelect"
                    [closeOnSelect]="closeDropdownOnSelect"
                    [required]="required"
                    [searchable]="true"
                    [searchFn]="searchContacts"
                    [hideSelected]="hideSelected"
                    bindLabel="first_name">
                    <ng-template ng-label-tmp let-item="item" *ngIf="!multiSelect">
                        <span (click)="selected && openAddContactModal(selected)"
                            class="ng-value-label"><b>{{item.first_name}} {{item.last_name}}</b></span>
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" *ngIf="multiSelect">
                        <div class="ng-value">
                            <span class="ng-value-label">{{items.length}} Selected</span>
                        </div>
                    </ng-template>
                    <ng-template class="contact-template" ng-option-tmp let-item="item">
                        <div class="ng-option-tmp">{{item.first_name}} {{item.last_name}}</div>
                    </ng-template>
                </ng-select>
                <button class="uk-button uk-button-nobutton add-button" tabindex="-1"
                    (click)="openAddContactModal(null)" type="button">
                    <i class="fas fa-plus"></i>
                </button>
                <div class="label grey">
                    <span *ngIf="(!multiSelect && !selected) || (multiSelect && selected?.length === 0)">
                        Add
                    </span>
                    {{ controlName }}
                </div>
            </div>
            <div *ngIf="editing && optionContacts.length <= 0" class="adding-button-inside">
                <button class="uk-button uk-button-nobutton" (click)="openAddContactModal(null)" type="button">
                    <i class="fas fa-plus"></i> Add {{ controlName }}
                </button>
            </div>
        </div>
    </div>
</div>